var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import DroppableModifier from './droppable';
import { action } from '@ember/object';
import { Events } from '../utils/events';
import { tracked } from '@glimmer/tracking';
import SortableListPlaceholder from '../plugins/sortable-list-placeholder';
import { isDestroying, isDestroyed } from '@ember/destroyable';
let SortableListModifier = (_class = class SortableListModifier extends DroppableModifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "plugins", []);
    _initializerDefineProperty(this, "targetIndex", _descriptor, this);
    _initializerDefineProperty(this, "isCurrentlyDragged", _descriptor2, this);
  }
  get context() {
    return {
      ...this.named.context,
      items: this.items
    };
  }
  get items() {
    return this.named.items ?? [];
  }
  get groupName() {
    return this.named.groupName ?? '';
  }
  attach() {
    super.attach();
    let plugins = [new SortableListPlaceholder(this)];
    this.plugins = plugins;
    this.plugins.forEach(plugin => plugin.attach());
    this.flyDragDropManager.on(Events.DragStart, this.onDragStart);
    this.flyDragDropManager.on(Events.DragEnd, this.onDragEnd);
  }
  cleanup() {
    super.cleanup();
    this.flyDragDropManager.off(Events.DragStart, this.onDragStart);
    this.flyDragDropManager.off(Events.DragEnd, this.onDragEnd);
  }
  onDragStart(event) {
    // Check if this droppable is a child of the draggable. This is possible in
    // nested scenarios.
    let draggableElement = event.target;
    this.isCurrentlyDragged = draggableElement !== this.droppableElement && draggableElement.contains(this.droppableElement);
  }
  onDragOver(event) {
    super.onDragOver(event);
    if (!this.canDrop || !event.detail.context.droppable) {
      return;
    }
    let draggableElements = this.getDraggableElements();
    if (this.items.length === 0) {
      this.targetIndex = 0;
      let newEvent = new CustomEvent(Events.DragSort, {
        detail: {
          context: {
            ...(event.detail.context ?? {}),
            currentIndex: null,
            targetIndex: 0,
            targetElement: this.droppableElement,
            position: null
          }
        }
      });
      this.droppableElement.dispatchEvent(newEvent);
      if (typeof this.named.onDragSort === 'function') {
        this.named.onDragSort(newEvent);
      }
      return;
    }
    let clientX = event.detail.clientX ?? 0;
    let clientY = event.detail.clientY ?? 0;
    let targetElement = document.elementFromPoint(clientX, clientY);
    let closestDraggableElement = targetElement ? targetElement.closest('[data-fly-draggable]') : null;

    // Don't do anything if no draggable was found, for example when we're
    // hovering over some other node.
    // Similarly, if a draggable was found but is not one of this.droppableElement's
    // draggables, ignore it.
    // We don't hide the drop indicator at this point, because we want it to
    // always show at the last valid position.
    if (!closestDraggableElement || !draggableElements.find(element => element === closestDraggableElement)) {
      return;
    }
    let coordinates = closestDraggableElement.getBoundingClientRect();
    let inTop = clientY < coordinates.top + coordinates.height / 2;
    let position = inTop ? 'top' : 'bottom';
    let {
      currentIndex,
      targetIndex
    } = this.getIndexes(draggableElements, event.detail.context.draggableId, closestDraggableElement, position);
    this.targetIndex = targetIndex;
    let newEvent = new CustomEvent(Events.DragSort, {
      detail: {
        context: {
          ...(event.detail.context ?? {}),
          currentIndex,
          targetIndex,
          targetElement: closestDraggableElement,
          position
        }
      }
    });
    this.droppableElement.dispatchEvent(newEvent);
    if (typeof this.named.onDragSort === 'function') {
      this.named.onDragSort(newEvent);
    }
  }
  onDrop(event) {
    // A draggable in a sortable-list is a sortable-item.
    // sortable-items must be passed a container, which refers to the
    // sortable-list they're nested within.
    // We can retrieve the source list and index by checking which
    // sortable-list the current draggable is attached to.
    //
    // The droppable refers to the sortable-list we're dropping into. This
    // may be the same component as draggable.container, if we're dragging
    // within one list. This may be another sortable-list if we're dragging
    // between multiple lists (or nested lists).

    let draggableInstance = this.flyDragDropManager.draggableMap[event.detail.context.draggableId];
    let itemGroupListInstance = Object.values(this.flyDragDropManager.droppableMap).find(i => i.groupName === draggableInstance.groupName);
    if (!itemGroupListInstance) {
      return;
    }
    let sourceIndex = itemGroupListInstance.items.indexOf(draggableInstance.item);
    if (typeof this.named.onSortableDrop === 'function') {
      this.named.onSortableDrop({
        targetIndex: this.targetIndex,
        targetList: this.items,
        sourceIndex,
        sourceList: itemGroupListInstance.items,
        item: draggableInstance.item
      });
    }
  }
  onDragEnd() {
    // DragEnd gets called after a Drop. It's possible for a Drop to cause
    // rerenders (by rearranging items), which may cause this component to be
    // destroyed. If that happens, we can't call set on it anymore.
    if (isDestroying(this) || isDestroyed(this)) {
      return;
    }
    this.isCurrentlyDragged = false;
  }
  getDraggableElements() {
    return Array.from(this.droppableElement.querySelectorAll(`[data-fly-draggable][data-fly-sortable-group-name="${this.groupName}"]:not([data-fly-draggable-clone])`));
  }
  getIndexes(draggables, draggedDraggableId, overDraggable, position) {
    let draggableInstance = this.flyDragDropManager.draggableMap[draggedDraggableId];
    let currentIndex = draggables.indexOf(draggableInstance.draggableElement);
    if (draggableInstance.draggableElement === overDraggable) {
      return {
        currentIndex,
        targetIndex: currentIndex
      };
    }
    let targetIndex = draggables.indexOf(overDraggable);

    // If the item currently dragged is within this droppable, and the target
    // index is after that item, decrement the target. This is needed because
    // moving an item within the same list is REMOVE ITEM > ADD ITEM: the first
    // item removal affects the item indices that follow.
    if (currentIndex > -1 && targetIndex > currentIndex) {
      targetIndex = targetIndex - 1;
    }

    // If we're hovering over the bottom of a droppable, we want the drop to
    // happen underneath it, so we have to increment the target index. Don't
    // increment if targetIndex would exceed the list's length.
    if (position === 'bottom' && targetIndex < draggables.length) {
      targetIndex = targetIndex + 1;
    }
    return {
      currentIndex,
      targetIndex
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "targetIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isCurrentlyDragged", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "cleanup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cleanup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDrop", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getDraggableElements", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getDraggableElements"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getIndexes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getIndexes"), _class.prototype)), _class);
export { SortableListModifier as default };